import type { AvailabilityJob, AvailabilityRequest, CreateRequestPayload } from "../types";
import { apiClient } from "./apiClient";

export const availabilityRequestsApi = {
  list: () => apiClient<AvailabilityRequest[]>("/availability-requests"),
  get: (id: string) => apiClient<AvailabilityRequest>(`/availability-requests/${id}`),
  create: (payload: CreateRequestPayload) =>
    apiClient<AvailabilityRequest>("/availability-requests", {
      method: "POST",
      body: JSON.stringify(payload)
    }),
  delete: (id: string) =>
    apiClient<void>(`/availability-requests/${id}`, { method: "DELETE" }),
  updateElisaEventId: (jobId: string, elisaEventId: string | null) =>
    apiClient<AvailabilityJob>(`/jobs/${jobId}/elisa-event-id`, {
      method: "PATCH",
      body: JSON.stringify({ elisaEventId })
    })
};
